import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import TableComponent from '../../leastcomponent/customtable/customtable'
// import BreadCrumb from "../../leastcomponent/breadcrumb/breadcrumb";
import DeleteIconNew from '../../assets/svg/DeleteIconNew'
import EditIconNew from '../../assets/svg/EditIconNew'
import CustomButton from '../../leastcomponent/custombutton/custombutton'
import AddIcon from '@mui/icons-material/Add'
import DeleteWarningModal from '../../modals/deletewarningmodal'
import { useNavigate } from 'react-router-dom'
import BreadcrumbNavigation from '../commoncomponents/breadcrumbnavigation'

const MrpRunList = () => {
  const [deleteRecord, setDeleteRecord] = useState(false)
  const handleDeleteOpen = () => setDeleteRecord(true)
  const handleDeleteClose = () => setDeleteRecord(false)
  const navigate = useNavigate()
  const rows = [
    {
      id: 1,
      mrpNo: '123-456-789-0123',
      createdOn: '10/10/10, 10:10 ',
      createdy: 'Lorem Ipsum',
      forDate: '10/10/10, 10:10',
      scheduleUsed: 'Schedule ',
      action: 'action'
    },
    {
      id: 2,
      mrpNo: '123-456-789-0123',
      createdOn: '10/10/10, 10:10 ',
      createdy: 'Lorem Ipsum',
      forDate: '10/10/10, 10:10',
      scheduleUsed: 'Schedule ',
      action: 'action'
    },
    {
      id: 3,
      mrpNo: '123-456-789-0123',
      createdOn: '10/10/10, 10:10 ',
      createdy: 'Lorem Ipsum',
      forDate: '10/10/10, 10:10',
      scheduleUsed: 'Schedule ',
      action: 'action'
    },
    {
      id: 4,
      mrpNo: '123-456-789-0123',
      createdOn: '10/10/10, 10:10 ',
      createdy: 'Lorem Ipsum',
      forDate: '10/10/10, 10:10',
      scheduleUsed: 'Schedule ',
      action: 'action'
    },
    {
      id: 5,
      mrpNo: '123-456-789-0123',
      createdOn: '10/10/10, 10:10 ',
      createdy: 'Lorem Ipsum',
      forDate: '10/10/10, 10:10',
      scheduleUsed: 'Schedule ',
      action: 'action'
    },
    {
      id: 6,
      mrpNo: '123-456-789-0123',
      createdOn: '10/10/10, 10:10 ',
      createdy: 'Lorem Ipsum',
      forDate: '10/10/10, 10:10',
      scheduleUsed: 'Schedule ',
      action: 'action'
    },
    {
      id: 7,
      mrpNo: '123-456-789-0123',
      createdOn: '10/10/10, 10:10 ',
      createdy: 'Lorem Ipsum',
      forDate: '10/10/10, 10:10',
      scheduleUsed: 'Schedule ',
      action: 'action'
    }
  ]
  const columns = [
    { field: 'id', headerName: '#', flex: 0.2 },
    { field: 'mrpNo', headerName: 'MRP No.', flex: 1 },
    { field: 'createdOn', headerName: 'Created on', flex: 1 },
    { field: 'createdy', headerName: 'Created By', flex: 1 },
    { field: 'forDate', headerName: 'For Date', flex: 1 },
    { field: 'scheduleUsed', headerName: 'Schedule Used', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      disableClickEventBubbling: true,
      flex: 1,
      renderCell: () => {
        return (
          <Box className="resource-table-btn-main">
            <span className="process-delete">
              <EditIconNew />
            </span>
            <span onClick={handleDeleteOpen} className="process-delete">
              <DeleteIconNew />
            </span>
          </Box>
        )
      }
    }
  ]
  return (
    <Box className="production-team-head-overflow-hidden">
      <BreadcrumbNavigation
        breadCrumbData={null}
        pageTitle={'MRP'}
        backToLink={'/my-tickets'}
      />
      <Box className="common-parent-class-overflow-auto">
        {/* <BreadCrumb title="MRP" /> */}
        <Box>
          <Box className="common-parent-haeding-btn-div">
            <Typography className="common-tabel-heading">
              MRP runs list
            </Typography>
            <CustomButton
              variant="contained"
              title="New MRP Run"
              onClick={() => navigate('/add-mrp')}
              type="button"
              endIcon=""
              startIcon={<AddIcon />}
            />
          </Box>
          <TableComponent rows={rows} columns={columns} />
        </Box>
        {deleteRecord && (
          <DeleteWarningModal
            open={deleteRecord}
            handleOpen={handleDeleteOpen}
            handleClose={handleDeleteClose}
          />
        )}
      </Box>
    </Box>
  )
}

export default MrpRunList
